/**
 * Header Mega Menu functionality
 * Controls desktop mega menu and mobile navigation
 * 
 * @version 1.0.0
 */
document.addEventListener("DOMContentLoaded", () => {
  // Initialize desktop menu functionality
  initDesktopMenu();
  
  // Initialize mobile menu functionality
  initMobileMenu();
  
  // Initialize cart counter
  initCartCounter();
});

/**
 * Desktop mega menu functionality
 * Handles hover states and submenu activation
 * 
 * @returns {void}
 */
function initDesktopMenu() {
  const shopItem = document.querySelector('[data-menu-item="shop"]');
  const menu = shopItem?.querySelector('[data-mega-menu]');
  const triggers = menu?.querySelectorAll('[data-submenu]') || [];
  const panels = menu?.querySelectorAll('[data-submenu-content]') || [];
  let closeTimer = null;

  if (!shopItem || !menu) return;

  /**
   * Opens the mega menu
   */
  const openMenu = () => {
    clearTimeout(closeTimer);
    shopItem.classList.add("is-open");
  };

  /**
   * Schedules closing the mega menu after a delay
   */
  const scheduleClose = () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      shopItem.classList.remove("is-open");
    }, 150);
  };

  /**
   * Activates a specific submenu within the mega menu
   * @param {string} key - The submenu key to activate
   */
  const activateSubmenu = (key) => {
    panels.forEach(panel => {
      panel.classList.toggle("active", panel.dataset.submenuContent === key);
    });
    
    triggers.forEach(trigger => {
      trigger.querySelector("a").classList.toggle(
        "is-active", 
        trigger.dataset.submenu === key
      );
    });
  };

  // Event listeners
  shopItem.addEventListener("mouseenter", openMenu);
  menu.addEventListener("mouseenter", openMenu);
  shopItem.addEventListener("mouseleave", scheduleClose);
  menu.addEventListener("mouseleave", scheduleClose);

  // Set default active panel on hover
  shopItem.addEventListener("mouseenter", () => {
    const firstKey = triggers[0]?.dataset.submenu;
    if (firstKey) activateSubmenu(firstKey);
  });

  // Switch panels on hover
  triggers.forEach(trigger => {
    trigger.addEventListener("mouseenter", () => {
      activateSubmenu(trigger.dataset.submenu);
    });
  });
  
  // Add keyboard accessibility
  shopItem.querySelector('.nav__link')?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openMenu();
      const firstKey = triggers[0]?.dataset.submenu;
      if (firstKey) activateSubmenu(firstKey);
      
      // Focus the first menu item
      triggers[0]?.querySelector('a')?.focus();
    }
  });
  
  // Close mega menu on Escape key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && shopItem.classList.contains('is-open')) {
      shopItem.classList.remove('is-open');
      shopItem.querySelector('.nav__link')?.focus();
    }
  });
}

/**
 * Mobile menu functionality
 * Handles mobile navigation toggle and dropdowns
 * 
 * @returns {void}
 */
/**
 * Mobile menu functionality
 * Handles mobile navigation toggle and dropdowns
 * 
 * @returns {void}
 */
function initMobileMenu() {
  const mobileToggle = document.querySelector('.header__mobile-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const dropdownHeadings = document.querySelectorAll('.mobile-menu__heading');
  
  if (!mobileToggle || !mobileMenu) return;
  
  /**
   * Toggles the mobile menu open/closed state
   * @param {boolean} isOpen - Whether to open or close the menu
   */
  const toggleMobileMenu = (isOpen) => {
    mobileMenu.classList.toggle('is-open', isOpen);
    mobileToggle.setAttribute('aria-expanded', isOpen);
    mobileMenu.setAttribute('aria-hidden', !isOpen);
    
    // Add/remove class on body to prevent background scrolling
    if (isOpen) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }
  };
  
  mobileToggle.addEventListener('click', () => {
    const isCurrentlyOpen = mobileMenu.classList.contains('is-open');
    toggleMobileMenu(!isCurrentlyOpen);
  });
  
  // Handle dropdown toggles
  dropdownHeadings.forEach(heading => {
    heading.addEventListener('click', () => {
      const dropdown = heading.closest('.mobile-menu__dropdown');
      dropdown.classList.toggle('mobile-menu__dropdown--open');
    });
  });

  // Close mobile menu on escape key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
      toggleMobileMenu(false);
    }
  });
  
  // Close mobile menu when clicking outside
  document.addEventListener('click', (event) => {
    const isMenuOpen = mobileMenu.classList.contains('is-open');
    const isToggleClick = mobileToggle.contains(event.target);
    const isMenuClick = mobileMenu.contains(event.target);
    
    if (isMenuOpen && !isToggleClick && !isMenuClick) {
      toggleMobileMenu(false);
    }
  });
}

/**
 * Initialize cart counter functionality
 * Updates the cart count indicator
 * 
 * @returns {void}
 */
function initCartCounter() {
  // Initialize all cart counters with the current cart count
  const cartCountElements = document.querySelectorAll('.header-cart-count');
  
  cartCountElements.forEach(counter => {
    // Hide counter if cart is empty
    if (parseInt(counter.textContent) === 0) {
      counter.style.display = 'none';
    }
  });
  
  // Listen for cart updates from the theme
  document.addEventListener('cart:updated', function(event) {
    if (event.detail && typeof event.detail.cart !== 'undefined') {
      updateCartCount(event.detail.cart.item_count || 0);
    }
  });
  
  /**
   * Updates all cart count indicators
   * @param {number} count - The new cart count
   */
  function updateCartCount(count) {
    const cartCounters = document.querySelectorAll('.header-cart-count');
    
    cartCounters.forEach(counter => {
      counter.textContent = count;
      
      // Hide counter if cart is empty
      if (count === 0) {
        counter.style.display = 'none';
      } else {
        counter.style.display = '';
      }
    });
  }
}